import React from 'react';
import stylesInput from './input.module.css';

import { getDefinedValue, getDefinedItem } from '../../util/tools';

class InputText extends React.Component {

	refInput = null;
	cursorStart = 0;
	cursorEnd = 0;

	/*
		id
		value
		readOnly
		inputType // text, password
		autoComplete // on, off
		validator {
			isValueValid - function
			validBackground
			invalidBackground
		}
		onChange
		styles
			input
	*/
	constructor(props) {
		super(props);
		this.refInput = React.createRef();
		this.state = {value: getDefinedValue(props.value, '')};
	}
	completeComponentDidUpdate() {
		this.setCursorPositions();
	}
	setCursorPositions = () => {
		//reset the cursor position for input
		if( this.refInput.current ) {
			this.refInput.current.selectionStart = this.cursorStart;
			this.refInput.current.selectionEnd = this.cursorEnd;
		}
	};
	updateValue = (value) => {
		this.setState({ value: value });
	}
	handleValueChange = e => {
		let value = e.target.value;
		this.cursorStart = e.target.selectionStart;
		this.cursorEnd = e.target.selectionEnd;
		if( this.props.validator ) {
			
		}
		if( this.props.onChange ) {
			this.props.onChange(this.props.id, e, value);
		}
		this.setState({ value: value });
	}
	handleOnFocus = e => {
		this.cursorStart = e.target.selectionStart;
		this.cursorEnd = e.target.selectionEnd;
	}
	handleOnClick = e => {
		this.cursorStart = e.target.selectionStart;
		this.cursorEnd = e.target.selectionEnd;
	}

	render() {
		let readOnly = getDefinedValue( this.props.readOnly, false);
		let inputStyle = Object.assign({}, getDefinedItem(this.props, ['styles', 'input']));
		let type = getDefinedValue( this.props.inputType, 'text');
		let autoComplete = getDefinedValue( this.props.autoComplete, 'on');
		return (
			<input type={type} ref={this.refInput} className={stylesInput.inputFieldString} style={inputStyle} 
				autoComplete={autoComplete} readOnly={readOnly}
				value={this.state.value} onChange={ this.handleValueChange} 
				onFocus={this.handleOnFocus} onClick={this.handleOnClick}
			/>
		);
	}	
}

export default InputText;
